import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { translate } from 'containers/services/translate';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import { Config, Listings } from 'containers/AppContainer/typings';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  getInjuredVictimReasons,
  isOtherReasonSelected,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { VictimType } from 'typings/globalTypes';
import { CIVIL_JUDGEMENT_VICTIM_FIELDS } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
export interface BeneficiaryWithoutCompensationProps {
  intl: IntlShape;
  listings: Listings;
  beneficiary: any;
  index: any;
  judgementOnMerits: any;
  isManager: boolean;
  deceasedVictimsToShow: any;
  setDeceasedVictimsToShow: Function;
  victim: VictimType;
  showFuneralFees: any;
  setShowFuneralFees: Function;
  lossDate: any;
  handleChangeBeneficiaries: Function;
  handleChange: Function;
  mode: any;
  beneficiaryWithNonCompensation: any;
  isNew: boolean;
}
export const beneficiaryStyle = {
  width: '100%',
  marginTop: '10px',
  paddingBottom: '30px',
  paddingTop: '20px',
  paddingLeft: '20px',
  boxShadow: '0px 1px 3px #0880bc',
  borderRadius: '4px',
};

const BeneficiaryWithoutCompensation: React.FC<BeneficiaryWithoutCompensationProps> = ({
  beneficiary,
  index,
  ...props
}): JSX.Element => {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={3}>
        <FormControl fullWidth>
          <InputLabel>
            {translate({ ...messages.reasonField }, props)}
          </InputLabel>
          <Select
            name={CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON}
            id={CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON}
            value={get(
              props.beneficiaryWithNonCompensation,
              CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
              '',
            )}
            onChange={
              props.isNew
                ? props.handleChange(CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON)
                : props.handleChange(props.victim?.id, index)
            }
            disabled={
              !props.isManager &&
              get(props.judgementOnMerits, 'judgementOnMerits.status') !==
                STATUS_REJECTED &&
              !isEmpty(props.judgementOnMerits)
            }
          >
            {getInjuredVictimReasons(props.listings, props.mode).map(
              (item: Config) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.title}
                </MenuItem>
              ),
            )}
          </Select>
        </FormControl>
      </Grid>
      {isOtherReasonSelected(
        get(props.listings, 'civilJudgementVictimReason', []),
        get(
          props.beneficiaryWithNonCompensation,
          CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
          '',
        ),
        props.mode,
      ) && (
        <Grid item xs={3} className="other-item">
          <TextField
            name={CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON}
            value={get(
              props.beneficiaryWithNonCompensation,
              CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON,
              '',
            )}
            onChange={
              props.isNew
                ? props.handleChange(CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON)
                : props.handleChange(props.victim?.id, index)
            }
            disabled={
              !props.isManager &&
              get(props.judgementOnMerits, 'judgementOnMerits.status') !==
                STATUS_REJECTED &&
              !isEmpty(props.judgementOnMerits)
            }
          />
        </Grid>
      )}
    </Grid>
  );
};

export default injectIntl(BeneficiaryWithoutCompensation);
